import React, { Component, PropTypes } from 'react';
import ReactSparkSelectInput from '../../widgets/ReactSparkSelectInput';
import { languagesWithCodes } from '../../../constants/labelsConstants';
import { fetchLabels } from '../../helpers/fetchLabels';
import store from '../../../store/Store';
import ReactSparkConfirmationDialog from '../../widgets/ReactSparkConfirmationDialog';
import * as ActionTypes from '../../../constants/ActionTypes';

class LabelsContainer extends Component {
    constructor(props, context) {
        super(props, context);
        const languageCode = languagesWithCodes.find(elem => {
            return elem.code === this.props.languageCode;
        });
        this.state = {
            language: languageCode && languageCode.name,
            confirmationOpened: false,
            languageCode: 'en-US'
        };
        this.onLanguageChange = this.onLanguageChange.bind(this);
        this.changeLanguage = this.changeLanguage.bind(this);
    }
    changeLanguage(language) {
        const { chainId, hotelId } = this.props;
        const languageCode = languagesWithCodes.find(elem => {
            return elem.code === language;
        });
        this.setState({ language: languageCode.name, languageCode: languageCode.code });
        fetchLabels(chainId, hotelId, languageCode.code, this.props.setLabels, this.props.setHigherOrderLabels);
    }
    componentWillReceiveProps(nextProps) {
        if (this.props.languageCode !== nextProps.languageCode) {
            const languageCode = languagesWithCodes.find(elem => {
                return elem.code === nextProps.languageCode;
            });
            this.setState({ language: languageCode.name, languageCode: languageCode.code });
        }
    }
    onLanguageChange(event) {
        if (store.getState().app.data.labels.labels.changed) {
            this.setState({
                confirmationOpened: true,
                pendingLanguageChange: event.target.value
            });
        } else {
            this.changeLanguage(event.target.value);
        }
    }

    capitalize(word) {
        return word[0].toUpperCase() + word.slice(1);
    }

    render() {
        const languageListSorted = _.sortBy(this.props.languageList, ['name']);

        return (
            <div className="spark-panel__content">
                <section className="row spark-panel__section">
                    <div className="col-xs-12">
                        <h3>{this.props.heading}</h3>
                    </div>
                </section>
                <section className="row spark-panel__section">
                    <div className="col-xs-4">
                        <ReactSparkSelectInput
                            label="Label Language"
                            defaultValue={this.state.languageCode}
                            values={languageListSorted.map(v => {
                                return { key: v.code, label: v.name };
                            })}
                            onChange={this.onLanguageChange}
                            disabled={this.props.isDisabled}
                        />
                        {this.props.saveButton && this.props.saveButton}
                    </div>
                </section>
                <div className="custom-fields-font">
                    <span className="asterisk-color">*</span> Custom Fields
                </div>
                {this.props.children}
                <ReactSparkConfirmationDialog
                    open={this.state.confirmationOpened}
                    headLine="All changes will be lost"
                    message={`All changes will be lost. Do you want to save them?`}
                    onPrimaryClick={() => {
                        this.props.onSave(true).then(() => {
                            this.changeLanguage(this.state.pendingLanguageChange);
                            this.setState({ confirmationOpened: false });
                            store.dispatch({ type: ActionTypes.LABELS_DISCARD_CHANGES });
                        });
                    }}
                    onSecondaryClick={() => {
                        this.changeLanguage(this.state.pendingLanguageChange);
                        this.setState({ confirmationOpened: false });
                        store.dispatch({ type: ActionTypes.LABELS_DISCARD_CHANGES });
                    }}
                />
            </div>
        );
    }
}

LabelsContainer.propTypes = {
    languageList: PropTypes.array
};

export default LabelsContainer;



// WEBPACK FOOTER //
// ./src/components/pages/labels/LabelsContainer.js